/** @file The display vertical scale of a profile, defaulted as format's effectiveProfile does (17.7). */
import type { Profile } from '@zilo/pose3d-format/types/profile';
import { degToRad } from '@zilo/pose3d-math/angle/degToRad';

/** `profile.zScaleView`, else `1 / cos(profile.camera.pitch)` (the ortho default). */
export function zScaleViewOf(profile: Profile): number {
  return profile.zScaleView ?? 1 / Math.cos(degToRad(profile.camera.pitch));
}
